<div class="popup-container tlms-popup">
	<header>
		<div class="header" style="display:block">{{heading}} Switch Point</div>
		<button class="close" style="top:-3px" (click)="close()">
			<mat-icon>close</mat-icon>
		</button>
	</header>
	<ng-container>
		<div style="padding: 16px 24px 16px 24px;">
			<div class="col-12" style="width: 100%;">
				<div *ngIf="isAdd" class="upload">
					<label class="label">Switch Point Code
						<span style="color:#ff0000">*</span>
					</label>
					<span class="content">
						<input type="text" id="switchpointcode" name="switchpointcode" required class="switchpointcode"
							[(ngModel)]="switchPointCode" maxlength="5" minlength="4">
					</span>
				</div>

				<div *ngIf="!isAdd" class="upload">
					<label class="label">Switch Point Code:</label>
					<span class="content">
						{{ switchPointCode }}
					</span>
				</div>

				<div class="upload">
					<label class="label">Cost Per M3
						<span style="color:#ff0000">*</span>
					</label>
					<span class="content">
						<input type="number" min="0" max="99" id="costperm3" name="costperm3" required class="costperm3"
							[(ngModel)]="costPerM3">
					</span>
				</div>

				<label *ngIf="enableError" class="errormsg"> {{errormsg}}</label>
			</div>
		</div>
		<div class="cfooter d-flex justify-content-between align-items-center popup-footer">
			<button (click)="onNoClick()" class="mCancel"> CANCEL
			</button>
			<button class="costpl-submit" style="display: inline" (click)="saveClick()">
				SAVE
			</button>
		</div>
	</ng-container>
</div>